var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountDeleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 162,
    viewBox: "0 0 163 162",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FAA100",
    opacity: 0.083,
    cx: 80.85,
    cy: 80.85,
    r: 80.85
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FAA100",
    opacity: 0.18,
    cx: 80.85,
    cy: 80.85,
    r: 54.67
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M59.29 60.83h40.81v33.88H59.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.85 47.74c-16.983 0-30.8 13.816-30.8 30.8s13.817 30.8 30.8 30.8 30.8-13.816 30.8-30.8-13.817-30.8-30.8-30.8zm17.171 20.528L79.067 89.591a2.367 2.367 0 0 1-3.252.276L63.97 80.39a2.37 2.37 0 0 1 2.96-3.7l10.09 8.07 17.46-19.642a2.37 2.37 0 0 1 3.542 3.15z",
    fill: "#FAA100",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDeleted);
export default __webpack_public_path__ + "static/media/account_deleted.a14eaa17eed4c40a0f2f69ba9073e4ab.svg";
export { ForwardRef as ReactComponent };